import React, { useContext, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import { useAuth } from "../../Context/AuthContext";
import { enquiryList } from "../../Services/EnqueryApi";
import NoResultFoundModel from "../components/NoResultFoundModal";
import {
  changeJobEnquiryStatus,
  jobEnquiryList,
} from "../../Services/Job Enquiry/JobEnquiryApi";
import StatusChangeModal from "../../StatusChangeModal";
import { Link } from "react-router-dom";
import SuccessPopupModal from "../components/SuccessPopupModal";

const JobEnquiryList = () => {
  const [stateChangeStatus, setStateChangeStatus] = useState("");

  const [showSuccessModal, setShowSuccessModal] = useState();
  const [totalRecords, setTotalRecords] = useState(-1);
  const [modelAction, setModelAction] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalCount, setTotalCount] = useState(null);
  const [pageSize, setPageSize] = useState(30);
  const [errorMessage, setErrorMessage] = useState(false);
  const [enquiryListData, setEnquiryListData] = useState([]);
  const [showStatusChangeModal, setShowStatusChangeModal] = useState(false);
  const { setLoader, user } = useAuth();
  console.log(user, "djksuahdi32987husd");

  useEffect(() => {
    GetMasterStateListData();
  }, []);
  const closeAllModal = () => {
    setShowSuccessModal(false);
  };

  const GetMasterStateListData = async (pageNumber, searchKeywordValue) => {
    // debugger
    // setLoader(true);
    try {
      const data = await jobEnquiryList({
        pageSize,
        pageNo: pageNumber - 1, // Page numbers are typically 0-based in API calls
        searchKeyword:
          searchKeywordValue === undefined ? searchKeyword : searchKeywordValue,

        // userKeyID: user.userKeyID
      });

      if (data) {
        if (data?.data?.statusCode === 200) {
          setLoader(false);
          if (data?.data?.responseData?.data) {
            const MasterStateListData = data.data.responseData.data;
            const totalItems = data.data?.totalCount; // const totalItems = 44;
            setTotalCount(totalItems);
            const totalPages = Math.ceil(totalItems / pageSize);
            setTotalPage(totalPages);
            setTotalRecords(MasterStateListData.length);
            setEnquiryListData(MasterStateListData);
          }
        } else {
          setErrorMessage(data?.data?.errorMessage);
          setLoader(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleSearch = (e) => {
    let searchKeywordValue = e.target.value;
    const trimmedValue = searchKeywordValue.replace(/^\s+/g, "");
    const capitalizedValue =
      trimmedValue.charAt(0).toUpperCase() +
      trimmedValue.slice(1).toLowerCase();
    if (searchKeywordValue.length === 1 && searchKeywordValue.startsWith(" ")) {
      searchKeywordValue = searchKeywordValue.trimStart();
      return;
    }
    setSearchKeyword(capitalizedValue);
    GetMasterStateListData(1, capitalizedValue);
  };

  const confirmStatusChange = async (row) => {
    try {
      const { jobEnquiryKeyID } = row; // Destructure to access only what's needed
      const response = await changeJobEnquiryStatus(jobEnquiryKeyID);

      if (response && response.data.statusCode === 200) {
        setShowStatusChangeModal(false);
        setStateChangeStatus(null);
        GetMasterStateListData(1, null);
        setShowSuccessModal(true);
        setModelAction("Job Enquiry status changed successfully.");
      } else {
        console.error(response?.data?.errorMessage);
        setShowSuccessModal(true);
        setModelAction("Failed to change employee status.");
      }
    } catch (error) {
      console.error("Error changing employee status:", error);
      setShowSuccessModal(true);
      setModelAction("An error occurred while changing the employee status.");
    }
  };

  const handleStatusChange = (row) => {
    setStateChangeStatus(row); // You can set only relevant data if needed
    setShowStatusChangeModal(true);
  };
  return (
    <>
      <div className="card w-full max-w-[50vh] mx-auto h-auto">
        <div className="card-body p-2 bg-white shadow-md rounded-lg">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h5 className="m-0 text-dark">Job Enquiry</h5>
            <button className="btn btn-primary btn-sm d-inline d-sm-none">
              <i className="fa-solid fa-plus" style={{ fontSize: "11px" }}></i>
              <span className="d-inline d-sm-none"> Add</span>
            </button>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-1">
            <input
              type="text"
              className="form-control "
              placeholder="Search Job Enquiry."
              style={{ maxWidth: "350px" }}
              value={searchKeyword}
              onChange={(e) => {
                handleSearch(e);
              }}
            />
          </div>

          <div
            className="table-responsive"
            style={{
              maxHeight: "75vh",
              overflowY: "auto",
              position: "relative",
            }}
          >
            <table className="table table-bordered table-striped">
              <thead
                className="table-light"
                style={{ position: "sticky", top: -1, zIndex: 1 }}
              >
                <tr>
                  <th className="text-center">Sr No</th>
                  <th className="text-center">First Name</th>
                  <th className="text-center">Last Name</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Phone</th>
                  <th className="text-center">Message</th>
                  <th className="text-center">Resume</th>
                  <th className="text-center">Enquiry Date</th>
                  {/* <th className="text-center">Status</th> */}
                </tr>
              </thead>
              <tbody>
                {enquiryListData?.map((row, idx) => (
                  <tr key={idx}>
                    {/* <td className="text-center">{(currentPage - 1) * pageSize + idx + 1}</td> */}
                    <td className="text-center">{idx + 1}</td>
                    <td className="text-center">{row.firstName}</td>
                    <td className="text-center">{row.lastName}</td>
                    <td className="text-center">{row.email}</td>
                    <td className="text-center">{row.phoneNumber}</td>
                    <td className="text-center">
                      {row.message?.length > 15 ? (
                        <Tooltip title={row.message}>{`${row.message?.substring(
                          0,
                          15
                        )}...`}</Tooltip>
                      ) : (
                        <>{row.message}</>
                      )}
                    </td>
                    <td className="text-center">
                      {" "}
                      {row.cvUrl ? (
                        <a
                          href={row.cvUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View CV
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">
                      {row.createdAt
                        ? dayjs(row.createdAt).format("DD/MM/YYYY")
                        : "-"}
                    </td>
                    {/* <td className="text-center">
                      <Tooltip
                        title={
                          row.status === "InActivate"
                            ? "Click to Activate"
                            : "Click to Deactivate"
                        }
                      >
                        <Link
                          onClick={() => handleStatusChange(row)}
                          style={{
                            color: row.status === "InActivate" ? "#dc3545" : "#198754",
                            fontWeight: 600,
                            textDecoration: "none",
                          }}
                        >
                          {row.status === "InActivate" ? "Inactive" : "Active"}
                        </Link>
                      </Tooltip>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
            {totalRecords <= 0 && (
              <NoResultFoundModel totalRecords={totalRecords} />
            )}
          </div>
          <div className="d-flex justify-content-end ">
            {/* {totalCount > pageSize && (
            <PaginationComponent totalPages={totalPage} currentPage={currentPage} onPageChange={handlePageChange} />
          )} */}
          </div>
        </div>
        <StatusChangeModal
          open={showStatusChangeModal}
          onClose={() => setShowStatusChangeModal(false)}
          onConfirm={() => confirmStatusChange(stateChangeStatus, user)} // Pass the required arguments
        />

        {showSuccessModal && (
          <SuccessPopupModal
            show={showSuccessModal}
            onHide={() => closeAllModal()}
            setShowSuccessModal={setShowSuccessModal}
            modelAction={modelAction}
          />
        )}
      </div>
    </>
  );
};

export default JobEnquiryList;
